const reportWebVitals = (onPerfEntry) => {
  if (typeof onPerfEntry === 'function') {
    const { onCLS, onINP, onFCP, onLCP, onTTFB } = require('web-vitals');
    onCLS(onPerfEntry);
    onINP(onPerfEntry);
    onFCP(onPerfEntry);
    onLCP(onPerfEntry);
    onTTFB(onPerfEntry);
  }
};

export default reportWebVitals;
